
import React from "react";
import { Timeline } from "react-twitter-widgets";

const Twitter = () => {
  return (
    <div>
      <div className="" style={{ border: "" }}>
        <div className="about-content">
          <Timeline
            dataSource={{
              sourceType: "profile",
              screenName: "BSSABihar",
            }}
            options={{
              height: "490", 
              width: "400",
            }}
            data-tweet-limit="50"
          />
        </div>
      </div>
    </div>
  );
};

export default Twitter;
